import { render, staticRenderFns } from "./ImportShopify.vue?vue&type=template&id=12ac55d2&"
import script from "./ImportShopify.vue?vue&type=script&lang=js&"
export * from "./ImportShopify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports